/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

// component
import { Button, Modal, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

// misc
import { useDeleteProject } from "@/api/projects";
import replaceUrlParams from "@/utils/string/replaceUrlParams";
import { NAV_PROJECTS } from "@/constants";

export const DeleteProject = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const { workspaceId, projectId } = useParams();
  const params = {
    workspaceId: workspaceId as string,
    projectId: projectId as string,
  };
  
  // Mutation hook for deleting project
  const { mutate: deleteProject, isLoading: isDeletingProject } = useDeleteProject();
  // Callback function for project deletion
  const onDelete = () => {
    deleteProject(params, {
      onSuccess: () =>
        navigate(
          replaceUrlParams(NAV_PROJECTS, {
            workspaceId: workspaceId as string,
          })
        ),
    });
  };

  return (
    <>
      <Button danger type="link" size="large" icon={<DeleteOutlined />} onClick={() => setDeleteModalOpen(true)}></Button>
      {/* Delete Project Modal */}
      <Modal
        centered
        destroyOnClose
        closable={false}
        mask
        open={deleteModalOpen}
        title={t("project_single.delete_title")}
        okText={t("common.delete")}
        okButtonProps={{ danger: true, loading: isDeletingProject }}
        cancelText={t("common.cancel")}
        onOk={onDelete}
        onCancel={() => setDeleteModalOpen(false)}
      >
        <Typography.Paragraph className="mb-4">{t("project_single.delete_description")}</Typography.Paragraph>
      </Modal>
      {/* ./Delete Project Modal */}
    </>
  );
};
